import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownComponent } from './drop-down.component';
import { MatBadgeModule, MatButtonModule, MatChipsModule, MatFormFieldModule, MatIconModule, MatInputModule, MatListModule, MatSelectModule } from '@angular/material';
import { OverlayModule } from '@angular/cdk/overlay';
import {A11yModule} from '@angular/cdk/a11y'
import { FlexModule } from '@angular/flex-layout';



@NgModule({
  declarations: [DropDownComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    OverlayModule,
    A11yModule,
    MatButtonModule,
    MatChipsModule,
    FlexModule,
    MatSelectModule,
    MatListModule,
    MatBadgeModule
    
  ],
  exports:[DropDownComponent]
})
export class DropDownModule { }
